import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SpinnerComponent } from '../../../../utils/spinner/spinner.component';
import { Router } from '@angular/router';
import { LocationService } from '../../../../../services/resources/location.service';
import { AConcreteResource } from '../../../../AConcreteResource';
import { LocationModel } from '../../../../../models/resources/location.model';
import { HttpErrorsService } from '../../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../../services/utils/custom-notification.service';
import { SafeUpdateService } from '../../../../../services/utils/safe-update.service';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MdbButtonComponent } from '../../../../utils/mdb-button/mdb-button.component';
import { AddressFormComponent } from '../../../../forms/address-form/address-form.component';

@Component({
  selector: 'app-location-data',
  imports: [
    AddressFormComponent,
    MdbButtonComponent,
    SpinnerComponent
  ],
  templateUrl: './location-data.component.html',
  styleUrl: './location-data.component.scss',
})
export class LocationDataComponent extends AConcreteResource<LocationModel> {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    router: Router,
    private locationService: LocationService,
    private httpErrorsService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
  ) {
    super(router, locationService);
  }

  submit(serverResource: any = null, overrideValues: {[key: string]: any} = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = this.formGroup?.value;

    resource.updatedAt = this.model()!.updatedAt;
    resource.address.id = this.model()!.address!.id;
    resource.address.updatedAt = this.model()!.address!.updatedAt;

    if (serverResource)
      resource = this.safeUpdateService.handleResource(resource, serverResource, overrideValues)

    this.locationService
      .update(this.model()!.id, resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED');
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorsService.handleError(e,(newServerResource, newOverrideValues) => {
            this.submit(newServerResource, newOverrideValues);
          });
        },
      });
  }
}
